module.exports = __webpack_public_path__ + "static/media/SIJMorning.5b11f557.png";